
class SourceRepository {
    constructor(API) {
        this.API = API;
    }

   getSource(SourceClass) {
       return new SourceClass(this.API);
    }
}


export default SourceRepository
